window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  // cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: false,
  disableStats: true,
  wsHost: window.location.hostname,
  wsPort: window.location.port,
  enabledTransports: ['ws', 'wss'],
});

window.Echo.channel('global').listenToAll((evt, msg) => {
  console.log(`test message received ${evt}`);
  console.log(msg);
});

window.listenForProcessChanges = (processCode) => {


  document.addEventListener('DOMContentLoaded', () => {


    window.Echo.channel(`process.${processCode}`).listenToAll((evt, data) => {
      console.log(`process updated ${evt}`);
      console.log(data);
      // window.process = data.process;
      let event = new CustomEvent('items-load', {
        detail: {
          process: data.process,
        },
      });

      if (data.process.current_step === 'done') {
        return location.reload();
      }
      window.dispatchEvent(event);

    });
  });
};

console.log('listening...');
